import { cookies } from '@/shared/lib/cookies'

const termsCookie = 'portal-accept-terms'

export function isTermsAccepted() {
    return Boolean(cookies.get(termsCookie))
}

export function acceptTerms() {
    cookies.set(termsCookie, `${Date.now()}`, {
        path: '/',
        expires: 365,
        samesite: 'none',
        secure: true,
    })
}
